import { useEffect, useState } from 'react'

/**
 * Devuelve el timestamp actual (Date.now()) y se actualiza cada `intervalMs`
 * para que componentes tipo "hace 5m" se refresquen sin reload.
 *
 * Default 30s: suficientemente granular para texto tipo "hace 1m" sin
 * re-renderizar todo el árbol cada segundo.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}